import * as MockSettings from './MockSettings'
import * as ProdSettings from './ProdSettings'

const Settings = process.env.REACT_APP_ENV === 'production' ? ProdSettings : MockSettings
const SUPPORT_LINK = Settings.SUPPORT_LINK

export {
  SUPPORT_LINK  
}